import {Country} from "../defs/country";
import {CountryGroup} from "../defs/group";

export const Eswatini: Country = {
    identifier: "Eswatini",
    name: "Eswatini",
    countryCode: "SZ",
    group: CountryGroup.AFRICA,
    isUNMember: true,
    flag: "🇸🇿",
    svgPath: "m 564.55775,537.9284 0.056,0.045 0.259,0.143 0.023,0.286 -0.025,0.326 -0.052,0.206 0.02,0.205 0.083,0.32 0.079,0.219 0.019,0.998 -0.088,-0.046 -0.159,-0.043 -0.085,0.02 -0.077,0.449 -0.06,0.667 0.036,0.415 -0.606,0.013 -0.766,-0.045 -0.549,-0.18 -0.592,-0.395 -0.351,-0.616 -0.154,-0.386 -0.215,-0.022 -0.035,-0.066 -0.019,-0.471 0.004,-0.493 0.041,-0.131 0.398,-0.607 0.247,-0.376 0.154,-0.363 0.335,-0.427 0.358,-0.272 0.133,-0.039 0.092,0.011 0.632,0.374 0.648,0.355 0.142,-0.04 z",
}
